<!-- eslint-disable vue/no-v-html -->
<template>
  <button
    class="flex min-h-24 w-full items-stretch rounded-lg text-left"
    :class="{
      [backgroundColorToTailwindMap[backgroundColor!]]: !!backgroundColor && !selected,
      'bg-grey-25': !backgroundColor && !selected,
      'bg-[#384C66]': selected,
    }"
    @click.stop="$emit('icon:clicked')"
  >
    <div
      class="min-w-2 rounded-l-lg"
      :class="{
        [leadingColorToTailwindMap[leadingColor!]]: !!leadingColor,
      }"
    ></div>

    <div class="flex w-full flex-1 items-center text-clip py-[10px] pl-4 pr-2">
      <div class="flex items-center gap-4">
        <gv-image class="size-10" :src="props.icon" :alt="title + ' icon'" />
        <div class="flex w-[175px] flex-1 flex-col 3xs:w-[214px] 2xs:w-[248px] xs:w-[344px]">
          <div class="flex items-center gap-2">
            <gv-type uplifted-variant="subtitle-sm" :text="title" breakpoint="none" :class="{ 'text-white': selected }" />
            <ui-issue-status-badge :issue-status="issueStatus" />
          </div>
          <div
            class="line-clamp-2 overflow-hidden text-ellipsis font-proxima-nova text-[1rem] font-normal leading-[1.4]"
            :class="{ 'text-white': selected }"
            v-html="useSanitiseHtml(description)"
          ></div>
        </div>
      </div>

      <div class="ml-auto flex h-full flex-col justify-center">
        <gv-icon name="add_box" size="md" class="cursor-pointer" :class="{ 'fill-white': selected }" />
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useSanitiseHtml } from '@/common';
import { HazardIssueStatus, UiListTileBackgroundColor, UiListTileLeadingColor } from '@/features/hazards';

const props = defineProps<{
  leadingColor?: UiListTileLeadingColor;
  backgroundColor?: UiListTileBackgroundColor;
  title?: string;
  description?: string;
  icon?: string;
  selected?: boolean;
  issueStatus?: HazardIssueStatus;
}>();

defineEmits<{
  (event: 'icon:clicked'): void;
}>();

const leadingColorToTailwindMap = {
  [UiListTileLeadingColor.Black]: 'bg-black',
  [UiListTileLeadingColor.Gray]: 'bg-gray',
  [UiListTileLeadingColor.Blue]: 'bg-blue',
  [UiListTileLeadingColor.Yellow]: 'bg-yellow',
  [UiListTileLeadingColor.Orange]: 'bg-orange',
  [UiListTileLeadingColor.Red]: 'bg-red',
};

const backgroundColorToTailwindMap = {
  [UiListTileBackgroundColor.Pink]: 'bg-pink-50',
  [UiListTileBackgroundColor.Orange]: 'bg-orange-50',
};
</script>
